import { Injectable } from '@angular/core';
import { CountryImg } from '../enums/country-img.enum';

@Injectable({
  providedIn: 'root',
})
export class CountryUtilsService {
  //增加语言需要增加这里的样式对应
  public classNames: { [key: string]: string } = {
    'zh-cn': 'country-China',
    'en-us': 'country-United_Kingdom',
    th: 'country-Thailand',
    vi: 'country-Vietnam',
    tr: 'country-Turkey',
    'pt-br': 'country-Brazil',
    ja: 'country-Japan',
  };

  /**
   * 获取国家classname
   *
   * @param lang 语系
   * @returns //
   */
  getcountryClassName(lang: string = 'zh-cn') {
    lang = lang.toLowerCase();
    if (this.classNames[lang]) return this.classNames[lang];
    return '';
  }

  // -------------------------------------------------------------------------
  // TODO: 以上代碼等待 getCountryFilePath() 完全取代 getcountryClassName() 後移除
  // -------------------------------------------------------------------------

  public imgFileName: { [key: string]: string } = {
    'zh-cn': CountryImg.China,
    'en-us': CountryImg.United_Kingdom,
    th: CountryImg.Thailand,
    vi: CountryImg.Vietnam,
    tr: CountryImg.Turkey,
    'pt-br': CountryImg.Brazil,
    ja: CountryImg.Japan,
  };

  /**
   * 获取国家圖片檔案路徑
   *
   * @param lang 语系
   * @returns String
   */
  getCountryFilePath(lang: string = 'zh-cn') {
    lang = lang.toLowerCase();
    if (!this.classNames[lang]) return '';

    return 'assets/images/media/flags/' + this.imgFileName[lang];
  }
}
